@if (iconName) {
  <div class="bv-empty-state__icon">
    <bv-icon [name]="iconName" size="xl"></bv-icon>
  </div>
}
@if (title) {
  <div class="bv-empty-state__title">{{ title }}</div>
}
@if (desc) {
  <div class="bv-empty-state__desc">{{ desc }}</div>
}
<div class="bv-empty-state__actions">
  <ng-content></ng-content>
</div>
